import {
    mdiAccount,
    mdiCalendarCheck, mdiChartLine,
    mdiInvoiceListOutline, mdiInvoiceMultiple,
    mdiViewDashboardVariant
} from "@mdi/js";

const menu = [
    {
        title: 'Dashboard',
        href: '/dashboard',
        icon: mdiViewDashboardVariant,
        usergroup: 'user'
    },
    {
        title: 'Charts',
        href: '/chart',
        icon: mdiChartLine,
        usergroup: 'user'
    },
    {
        title: 'Transactions',
        href: '/transactions',
        icon: mdiInvoiceListOutline,
        usergroup: 'user'
    },
    {
        title: 'Recurring Transactions',
        href: '/recurring-transactions',
        icon: mdiInvoiceListOutline,
        usergroup: 'user'
    },
    {
        title: 'Monthly Closures',
        href: '/monthly-closures',
        icon: mdiCalendarCheck,
        usergroup: 'user'
    },
    {
        title: 'Reports',
        href: '/report',
        icon: mdiInvoiceMultiple,
        usergroup: 'user'
    },
    {
        title: 'Users',
        href: '/user',
        icon: mdiAccount,
        usergroup: 'admin'
    },
];
export default menu;
